import React, { useState } from 'react'
import { useAtom } from 'jotai'
import { CaseDetail } from '../../../../models/CaseDetail'
import { Button } from '../../../ui/Button/Button'
import { Overlay } from '../../../ui/Sidebar'
import { RemindersHeaderInfo } from '../Reminders/Reminders'
import CaseNoteCreateView from './CaseNoteCreateView'
import { L } from '../../../providers/Lokalise'
import { profileAtom } from '../../../../api/profile/profile'
import { RestrictElementWithTooltip } from '../RestrictElementWithTooltip'

type CaseNotesProps = {
    caseDetails: CaseDetail
    onUpdated?: () => void
}

const CreateNoteOverlay: React.FC<CaseNotesProps> = ({
    caseDetails,
    onUpdated,
}): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false)
    const [authProfile] = useAtom(profileAtom)

    return (
        <>
            {!caseDetails?.isClosed && (
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <RestrictElementWithTooltip
                        restrictedAction={
                            !caseDetails?.allowedUpdateActionList.includes(
                                'Sagsbehandle'
                            )
                        }
                    >
                        <Button
                            type="primary"
                            onClick={() => setIsOpen(true)}
                            size="small"
                            style={{
                                width: 'fit-content',
                            }}
                            disabled={
                                !caseDetails?.allowedUpdateActionList.includes(
                                    'Sagsbehandle'
                                ) || authProfile.isImitator
                            }
                        >
                            {L('LØN_SAGS_NOTE_SIDEBAR_TILFØJ_NOTAT_KNAP')}
                        </Button>
                    </RestrictElementWithTooltip>
                </div>
            )}

            <Overlay
                isShowing={isOpen}
                hide={() => {
                    setIsOpen(false)
                }}
            >
                <RemindersHeaderInfo
                    name={caseDetails?.newlyHired.name}
                    caseNumber={caseDetails?.caseNumber}
                />
                <CaseNoteCreateView
                    caseDetails={caseDetails}
                    isOpen={isOpen}
                    onUpdated={() => {
                        setIsOpen(false)
                        onUpdated?.()
                    }}
                    onCancel={() => setIsOpen(false)}
                />
            </Overlay>
        </>
    )
}

export default CreateNoteOverlay
